import React from 'react';

const PropsLogger = (props: any) => {
	console.log('proplogger', props);
	return <></>;
};

export default PropsLogger;
